export enum SelectedPropertyType {
  Label,
  Property,
}
